import { SESSION_USER_ID_KEY } from "./VMConstants";

export const SUPERADMIN_USER_ID_HEADER = "x-superadmin-user-id";

/** Logged-in admin user id (session storage primary). */
export function getSuperAdminId() {
  if (typeof window === "undefined") return "";
  return sessionStorage.getItem(SESSION_USER_ID_KEY) || localStorage.getItem("superAdminId") || "";
}

/** Query auth: backend accepts user_id or super_admin_id. */
export function withAuth(params = {}) {
  const id = getSuperAdminId();
  if (!id) return params;
  return { ...params, user_id: id, super_admin_id: id };
}

/** Body auth for POST / PATCH / PUT. */
export function withAuthBody(body = {}) {
  const id = getSuperAdminId();
  if (!id) return body;
  return { ...body, user_id: id, super_admin_id: id };
}

/**
 * Axios config helper: auth query params + optional legacy header.
 */
export function withSuperAdminAuth(config = {}) {
  const id = getSuperAdminId();
  return {
    ...config,
    params: withAuth(config.params || {}),
    headers: {
      ...(config.headers || {}),
      ...(id ? { [SUPERADMIN_USER_ID_HEADER]: id } : {}),
    },
  };
}
